import { Link } from "react-router-dom";
import Paginate from "../../layout/Paginate";
import Button from "../../Shared/Button/Button";
import FilterHeader from "../../Shared/FilterHeader/FilterHeader";
import PaidListingFeesRow from "./PaidListingFeesRow";

const PaidListingFees = () => {
  return (
    <div className="col-span-3 mt-[60px]">
      <FilterHeader title={"Paid Listing Fees"} dropdown={false} />

      <div className="mt-[30px] mb-5 grid grid-cols-4 gap-x-2.5">
        <div></div>
        <div></div>
        <Link to="/user/unpaid">
          <Button
            text="Unpaid"
            variant="outline"
            className="!w-full !border-darkGreen !text-xl !text-darkGreen"
          />
        </Link>
        <Link to="/user/paid">
          <Button text="Paid" variant="primary" className=" !w-full !text-xl" />
        </Link>
      </div>
      <div className="">
        <div className="grid grid-cols-[90px_420px_auto_100px_200px] border border-lightGray px-6 py-5">
          <p className="font-pop text-sm font-bold text-darkGreen">Invoice</p>
          <p className="font-pop text-sm font-bold text-darkGreen">
            Auction Date ended
          </p>
          <p className="font-pop text-sm font-bold text-darkGreen">
            Amount Payable
          </p>
          <p className="font-pop text-sm font-bold text-darkGreen">Status</p>
          <p className="font-pop text-sm font-bold text-darkGreen"></p>
        </div>

        <Paginate
          element={(props) => <PaidListingFeesRow {...props} />}
          data={new Array(20).fill(0)}
          itemsPerPage={8}
          containerClassName="_"
        />
      </div>
    </div>
  );
};

export default PaidListingFees;
